import * as React from "react"
import { BsTwitter, BsLinkedin } from "react-icons/bs"
import { StaticImage } from "gatsby-plugin-image"
import RegularPage from "../layout/pagelayout"
import Seo from "../components/seo"

const AboutUsPage = ({ location }) => {
  return (
    <RegularPage location={location}>
      <h1>About me</h1>
      <StaticImage
        src="../images/amrish.png"
        className="author-img"
        alt="Amrish Kushwaha"
      />
      {/* <img alt={"Amrish Kushwaha"} src={`/amrish.png`} className="author-img" /> */}
      <p>I am Amrish Kushwaha. Software Engineer, Maker, Writer.</p>{" "}
      <p>
        I am currently focused on frontend development with curiosity of
        building end to end software system. Currently I am working at{" "}
        <a href="https://rafay.co" target="_blank" rel="noopener noreferrer">
          Rafay Systems
        </a>
        . I love to write as well as build side projects when I am free.
      </p>
      <p>
        Frontendroom is the project which I started to write the solutions of
        the problems related to UI.
      </p>
      <p>Feel free to contact me</p>
      <div>
        <a
          href="https://twitter.com/isamrishk"
          target="_blank"
          rel="noopener noreferrer"
          className="about-us--twitter"
        >
          <BsTwitter /> <span className="about-us-label">Twitter</span>
        </a>
        <a
          href="https://www.linkedin.com/in/isamrish/"
          target="_blank"
          rel="noopener noreferrer"
          className="about-us--linkedin"
        >
          <BsLinkedin /> <span className="about-us-label">Linkedin</span>
        </a>
      </div>
    </RegularPage>
  )
}

export const Head = () => <Seo title="About Page" isHome={true} />

export default AboutUsPage
